import React from 'react';
import { MEDIA_VARIANTS } from '../../media';
import { ImageLoader } from './ImageLoader';

export function ItemArtwork({ className = '', item, itemId, variant = MEDIA_VARIANTS.CARD }) {
  return (
    <ImageLoader
      alt=""
      animatedMediaId={item?.animatedMediaId || item?.animatedImageId || ''}
      className={`pl-item-artwork ${className}`.trim()}
      imageId={item?.imageId || ''}
      itemId={itemId || item?.id || ''}
      staticPreview
      variant={variant}
    />
  );
}

export function ItemQuantity({
  ariaLabel,
  className = '',
  disabled = false,
  onClick,
  quantity,
  title,
}) {
  const label = `${quantity}×`;
  if (!onClick) {
    return <span className={`pl-item-quantity ${className}`.trim()}>{label}</span>;
  }
  return (
    <button
      aria-label={ariaLabel}
      className={`pl-item-quantity ${className}`.trim()}
      disabled={disabled}
      onClick={onClick}
      title={title}
      type="button"
    >
      {label}
    </button>
  );
}
